var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.recipes.length)+" recipes")]),_c('pre',[_vm._v(_vm._s(_vm.recipes))])])}
var staticRenderFns = []

export { render, staticRenderFns }